var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-conteiner"},[_c('img',{staticClass:"img-no-data",attrs:{"src":require("../../../../../public/assets/noData.svg"),"alt":"noData"}}),_c('move-text',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("emptyText")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }